import { createTheme } from '@mui/material';

const theme = createTheme({
    palette: {
        primary: {
            main: '#ffc000',
        },
        secondary: {
            main: '#ff9e01',
        },
        ternary: {
            main: "#feb302"
        },
        darkBackground: {
            main: "#333333"
        },
        error: {
            main: '#DA3832',
        },
        warning: {
            main: '#FDC400',
        },
        success: {
            main: '#55AE58',
        },
        background: {
            default: '#fafaff',
        },
        strip: {
            main: '#fafafa',
        },
        gray: {
            main: '#808080',
        },
        row: {
            main: '#ffffff',
        },
    },
    typography: {
        // fontFamily: '"Roboto", sans-serif',
    },
    components: {
        MuiButton: {
            defaultProps: {
                disableElevation: true,
            },
            styleOverrides: {
                root: {
                    textTransform: 'initial',
                },
                outlined: {
                    color: 'black',
                },
            },
        },
    },
    overrides: {
        MuiTypography: {
            body2: {
                fontSize: '0.875rem',
            },
        },
    },
});

export default theme;
